class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
  this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

  this.summaryToggle.setAttribute('aria-expanded', 'true');
  event.target.closest('details').setAttribute('open', true);

  this.searchInput = this.querySelector('.search__input');

  // Force focus after DOM + layout settle
  setTimeout(() => {
    if (this.searchInput) {
      this.searchInput.removeAttribute('disabled');
      this.searchInput.focus({ preventScroll: true });
    }
  }, 500);


  // `overflow-hidden` alone doesn't block touch scroll on iOS Safari, so
  // pin body with `position: fixed` (same approach as ModalDialog).
  this._scrollY = window.scrollY || window.pageYOffset || 0;
  document.body.classList.add('overflow-hidden');
  document.body.style.position = 'fixed';
  document.body.style.top = `-${this._scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';

  setTimeout(() => {
    document.body.addEventListener('click', this.onBodyClickEvent);
  }, 0);

  trapFocus(
    this.detailsContainer.querySelector('[tabindex="-1"]'),
    this.searchInput
  );
}


  close(focusToggle = true) {
    if (!this.isOpen()) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
    }, 250);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    document.body.classList.remove('overflow-hidden');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    if (typeof this._scrollY === 'number') {
      window.scrollTo(0, this._scrollY);
    }
  }
}

customElements.define('details-modal', DetailsModal);
